import type { OutlookSpaceAssetKey, TimeStreamAssets } from 'owa-timestream-types';

export default function markAssetsByKeyAsDeleted(
    assets: TimeStreamAssets,
    keys: OutlookSpaceAssetKey[] | undefined
) {
    if (keys?.length) {
        const keysToDelete = keys.reduce(
            (m, v) => ((m[v] = true), m),
            {} as { [key: string]: boolean }
        );

        for (const asset of assets.values()) {
            if (asset.outlookSpaceAssetKey && keysToDelete[asset.outlookSpaceAssetKey]) {
                asset.deleted = true;
            }
        }
    }
}
